module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'controller',
        'controller',
    ],

    config: {
        showColorBar: true,
        tabConfigNavKey: 'employeeReports',
        showEditByMySelf: true,
    },
}